import { render, staticRenderFns } from "./HeartysanCategoryCreationSection.vue?vue&type=template&id=38c9a5ca&scoped=true"
import script from "./HeartysanCategoryCreationSection.vue?vue&type=script&lang=js"
export * from "./HeartysanCategoryCreationSection.vue?vue&type=script&lang=js"
import style0 from "./HeartysanCategoryCreationSection.vue?vue&type=style&index=0&id=38c9a5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9a5ca",
  null
  
)

export default component.exports